import React, { FC } from 'react';
import { ISkillsBlock } from 'core/interface/skills';

import '../CandidateSkills/candidate-skills.scss';
import './Index.scss';

const SkillsBlock: FC<ISkillsBlock> = ({ title }): JSX.Element => {
  const label = typeof title === 'string' ? title : String(title ?? '');
  return <span className="candidate-skill-chip candidate-skill-chip--saved">{label}</span>;
};

export default SkillsBlock;
